/**
 * O token ainda está no localStorage mas já venceu?
 *
 * Serve para distinguir duas situações que hoje se confundem: quem está
 * CHEGANDO no sistema depois de horas (token velho guardado) e quem teve a
 * sessão morrendo NO MEIO do trabalho. O primeiro não deve ver aviso nenhum —
 * veio para logar mesmo; o segundo deve.
 *
 * Sem `exp` no payload, devolve false de propósito: quem decide é o servidor.
 */
export function tokenExpirado(token) {
  const payload = parseJwt(token);
  if (!payload?.exp) return false;
  return payload.exp * 1000 <= Date.now();
}

export function parseJwt(token) {
  if (!token) return null;
  const base64Url = token.split('.')[1];
  if (!base64Url) return null;

  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  try {
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Erro ao decodificar token:", e);
    return null;
  }
}
